export default __webpack_public_path__ + "static/media/adblock.cbbb0c0e.svg";